enum GlowColourEnum {
  None = 'none',
  Yellow = 'yellow',
  Red = 'red',
}

export default GlowColourEnum;
